import { Trans, useTranslation } from "react-i18next";

import { TwoFactorChangeAuthQRCode } from "@/components/Portal/UserAccount/Security/Change/TwoFactorChangeAuthQRCode";
import { useManualSetupDefault } from "@/hooks/useManualSetupDefault";
import { SetUpTwoFactorAuthenticationReponse } from "@/services/model";

import { FAQLink } from "./FAQLink";
import { ManualKeyField } from "./ManualKeyField";
import { TwoFactorConfirmationInput } from "./TwoFactorConfirmationInput";

export const AuthenticatorAppForm = ({
  authSetupData,
}: {
  authSetupData?: SetUpTwoFactorAuthenticationReponse;
}) => {
  const { t } = useTranslation();
  const [showManualSetup, setShowManualSetup] = useManualSetupDefault();

  return (
    <>
      <div className="flex flex-col gap-4">
        <h2 className="text-base font-semibold text-foreground-primary">
          {t("portal:authenticator.app.setup.step1.title")}
        </h2>
        <p className="text-base text-foreground-primary">
          <Trans
            i18nKey="portal:authenticator.app.setup.step1.description"
            components={{ FAQ: <FAQLink /> }}
          />
        </p>
        <div className="flex flex-col items-center gap-4 rounded-md bg-surface-tertiary p-4">
          {showManualSetup ? (
            <>
              <ManualKeyField manualCode={authSetupData?.manualCode} />
              <button
                type="button"
                className="self-start text-sm text-foreground-primary underline"
                onClick={() => setShowManualSetup(false)}
              >
                {t("portal:authenticator.app.setup.step1.back-to-qr-code")}
              </button>
            </>
          ) : (
            <>
              <TwoFactorChangeAuthQRCode
                qrCodeData={authSetupData?.qrCodeUri}
              />
              <button
                type="button"
                className="self-start text-sm text-foreground-primary underline"
                onClick={() => setShowManualSetup(true)}
              >
                {t("portal:authenticator.app.setup.step1.enter-key-manually")}
              </button>
            </>
          )}
        </div>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base font-semibold text-foreground-primary">
          {t("portal:authenticator.app.setup.step2.title")}
        </h2>
        <p className="text-base text-foreground-primary">
          {t("portal:authenticator.app.setup.step2.description")}
        </p>
        <TwoFactorConfirmationInput />
      </div>
    </>
  );
};
